<tiime-secondary-filters
  [badge]="badgeNumber()"
  [badgeHidden]="badgeNumber() === 0"
>
  <div class="reset-button-container">
    <app-reset-button
      [disabled]="badgeNumber() === 0"
      (reset)="reset()"
    ></app-reset-button>
  </div>
  <div class="secondary-filters-line">
    <span class="secondary-filters-line-label">État</span>
    <div class="filters-type-container">
      <mat-button-toggle-group [formControl]="form().documentRequestStatus">
        <mat-button-toggle value='all'>Tous</mat-button-toggle>
        <mat-button-toggle [value]="DocumentRequestStatusEnum.REQUESTED">Demandé</mat-button-toggle>
        <mat-button-toggle [value]="DocumentRequestStatusEnum.RECEIVED">Transmis</mat-button-toggle>
        <mat-button-toggle [value]="DocumentRequestStatusEnum.CLOSED">Clôturés</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </div>
  <div class="secondary-filters-line accounting-period">
    <span class="secondary-filters-line-label">Exercice</span>
    <app-accounting-period-select
      [accountingPeriodFilter]="form().controls.accountingPeriod"
      [accountingPeriods]="accountingPeriods()"
      [allowEmpty]="true"
    ></app-accounting-period-select>
  </div>

</tiime-secondary-filters>
